import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { SegmentProps } from "./propType";

export default function Segment(props: SegmentProps) {
  const {
    className,
    disabled,
    prefixCls = "bm-Segment",
    value = [],
  }: any = props;
  const [activeIndex, setActiveIndex] = useState(props.activeIndex || 0);
  const styleClass = classNames(prefixCls, className);
  const handleClick = (index: number, item: string) => {
    if (disabled) {
      return;
    }
    setActiveIndex(index);
    if (props.onChange) {
      (props.onChange as (event: any) => void)({
        index,
        item,
      });
    }
  };

  useEffect(() => {
    setActiveIndex(props.activeIndex || 0);
  }, [props.activeIndex]);

  return (
    <div className={styleClass}>
      {value.map((item: string, index: number) => {
        const itemClass = classNames(`${prefixCls}-item`, {
          [`${prefixCls}-item-selected`]: activeIndex === index,
          [`${prefixCls}-item-disabled`]: disabled,
        });
        return (
          <div
            key={index}
            className={itemClass}
            onClick={handleClick.bind(this, index, item)}
          >
            {item.toString()}
          </div>
        );
      })}
    </div>
  );
}

